export const isStringSinglePoint = stringPoint => {
    if (/^-?\d+(\.\d+)?,-?\d+(\.\d+)?$/.test(stringPoint)) {
        return true;
    }
    return false;
};



// WEBPACK FOOTER //
// ./services/utils/pointUtils.js